<template>
  <div class="addEmployeeVue">
    <div class="o-main-content-area" v-loading="btnLoading">
      <!-- Heading Section -->
      <div class="row c-responsive-fixwidth">
          <div class="col-md-6">
              <h1 class="h1">Add Employee:</h1>
          </div>
          <div class="col-md-6 text-right">
              <ul class="o-filter-area">
                  <li><a href="javascript: void(0)" @click="backToEmployeeList()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a></li>
                  <li><a href="javascript: void(0)" @click="uploadService()" class="c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-save"></i> Save</a></li>
              </ul>

          </div>
      </div>
      <!-- /Heading Section -->
      <!-- Main Body Content area -->
      <!-- Tab nav area -->
      <div class="c-common-space c-responsive-fixwidth">
         <div class="o-tab-area clearfix">
              <div class="col-md-12 o-no-padding">
                  <ul class="o-tab-view o-tab-view--text">
                      <li><a href="javascript: void(0)" :class="(tab=='personal')?'active':'custom-deactive-btn'" @click="changeTab('personal')">Personal Information</a></li>
                      <li><a href="javascript: void(0)" :class="(tab=='skill')?'active':'custom-deactive-btn'" @click="changeTab('skill')">Skillset</a></li>
                      <li><a href="javascript: void(0)" :class="(tab=='availability')?'active':'custom-deactive-btn'" @click="changeTab('availability')">Availability & Vacation</a></li>
                      <li><a href="javascript: void(0)" :class="(tab=='admin')?'active':'custom-deactive-btn'" @click="changeTab('admin')">Admin Settings</a></li>
                  </ul>
              </div>
          </div>
      </div>
      <!-- /Tab nav area -->
      <!-- Components -->
      <addEmployeePersonal v-bind:id="'personal'" :empPersonalData="personalInfo" v-if="this.tab == 'personal'"/>
      <addEmployeeAdmin :adminSettingsData="adminSettingsData" v-if="this.tab == 'admin'"/>
      <addEmployeeSkills :skillData="skillData" v-if="this.tab == 'skill'" />
      <addEmployeeAvailability :weeklyVacationData="weeklyVacationData" v-if="this.tab == 'availability'"/>

    </div>
  </div>
</template>
<script>
    import addEmployeePersonal from './addEmployeePersonal';
    import addEmployeeAdmin from './addEmployeeAdmin';
    import addEmployeeSkills from './addEmployeeSkills';
    import addEmployeeAvailability from './addEmployeeAvailability';
    import {
        bus
    } from '../../main';
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';
    import {
        global
    } from '../../global.js';

    export default {

        components: {
            'addEmployeePersonal': addEmployeePersonal,
            'addEmployeeAdmin': addEmployeeAdmin,
            'addEmployeeSkills': addEmployeeSkills,
            'addEmployeeAvailability': addEmployeeAvailability
        },
        data() {
            return {
                btnLoading: false,
                tab: "personal",
                custom_field_1:'',
                custom_field_2:'',
                personalInfo: {
                    basicInfo: {
                        userName: '',
                        password: '',
                        cnfPassword: '',
                        firstName: '',
                        lastName: '',
                    },
                    address: {
                        streetAdd: '',
                        city: '',
                        state: '',
                        zip: '',
                        country: '',

                    },
                    PoBoxAddress: {
                        pbAdd: '',
                        city: '',
                        state: '',
                        zip: '',
                        country: '',

                    },
                    contact: {
                        email: '',
                        secEmail: '',
                        homePhone: '',
                        cellPhone: '',
                    },
                    identityField: {
                        driverLicense: '',
                        socialSecurity: '',
                        monthMaidenName: '',
                        dataOfBirth: '',
                    },
                    emergency: {
                        contactName: '',
                        contactNuber: '',
                        medicalCondition: '',
                        regularMeication: '',
                        homePhone: '',
                        cellPhone: '',
                        email: '',
                    },
                    new_files: [],
                    customFields:{
                        custom_field_1:'',
                        custom_field_2:'',
                    },
                    
                },
                skillData: {
                    selectedSkills: [],
                    updateAuthority: '',
                },
                adminSettingsData: {
                    memberSince: '',
                    dateOfHire: '',
                    totalShifts: '',
                    seniority: '',
                    status: '',
                },
                weeklyVacationData: {
                    sun: '',
                    mon: '',
                    tue: '',
                    wed: '',
                    thu: '',
                    fri: '',
                    sat: '',
                },
                emailExists:'',

            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
            })
        },
        methods: {
            getErrorMessage(errorMessage) {
                let msg = 'Something went wrong'
                if(errorMessage.cell_phone&&errorMessage.cell_phone.length) {
                    msg = errorMessage.cell_phone[0]
                } else if((typeof errorMessage) == 'string') {
                    let errMsg = JSON.parse(errorMessage);
                    if(errMsg.email&&errMsg.email.length) {
                        msg = errMsg.email[0]
                    }
                } 
                // console.log(errorMessage.email[0]);
                return msg;
            },
            changeTab(newTab) {
                this.tab = newTab;
            },
            backToEmployeeList() {
                this.$router.push({
                    path: `/employees`
                });
            },
            getAvailabilityFormat(dayInput) {
                if (dayInput != "") {
                    let unavailabilityList = dayInput.split(",");
                    let fomatedUnavailabilityList = {};
                    if (unavailabilityList.length > 0) {
                        for (let i = 0; i < unavailabilityList.length; i++) {
                            let fullDate = [];
                            let start = unavailabilityList[i].split("-")[0];
                            let end = unavailabilityList[i].split("-")[1];
                            fullDate.push(start);
                            fullDate.push(end);
                            fomatedUnavailabilityList[i + 1] = fullDate;
                        }
                        return fomatedUnavailabilityList;
                    } else {
                        return {};
                    }
                } else {
                    return {};
                }

            },

            async uploadService() {
                if (this.personalInfo.new_files.length != 0) {
                    await service.post('attachment/uploadSingleFile', {
                            'image_file': this.personalInfo.new_files[0].img,
                            'file_name': this.personalInfo.new_files[0].name
                        }, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        })
                        .then(async(res) => {
                            //console.log(res);
                            //resolve(res);
                            this.personalInfo.new_files[0].path = res.data.result.path;
                            this.personalInfo.new_files[0].uploaded = true;
                        }).catch((err) => {
                            console.log(err);
                            this.$message({
                                type: 'error',
                                message: this.$t('something_went_wrong')
                            });
                        });
                } 
                await this.openPhoneEmptyCheckConfirm();
            },

            async openPhoneEmptyCheckConfirm() {
                await this.saveEmployeeData();
                // let home_phone = this.personalInfo.contact.homePhone;
                // let cell_phone = this.personalInfo.contact.cellPhone;
                // if(home_phone == '' || home_phone == 0 || cell_phone == 0 || cell_phone == '') {
                //     this.$confirm('One or Both of your phone numbers are missing! Continue?', 'Warning', {
                //         confirmButtonText: 'Continue',
                //         cancelButtonText: 'Cancel',
                //         type: 'warning',
                //         }).then(async () => {
                //             await this.saveEmployeeData();
                //         }).catch(() => {
                //         this.$message({
                //             type: 'info',
                //             message: 'Employee Update canceled'
                //         });          
                //     });

                // }else {
                //     await this.saveEmployeeData();
                // }
            },

            async customValEmail(customEmailField) {
                // console.log("Check1")
                if (customEmailField != "") {
                    // console.log("Check2")
                    const filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,10})(\]?)$/;
                    if (filter.test(customEmailField)) {
                        // console.log("Check3")
                        await service.get('user/emailExists', {
                            'Authorization': this.userToken,
                            'email': customEmailField,
                        }).
                        then((res) => {
                            this.emailExists=res.data.result;
                            console.log(this.emailExists);
                            if(this.emailExists == 0){
                                this.$message({
                                    type: 'error',
                                    message: 'Email already exist.'
                                });
                            }
                        }).catch((err) => {
                            // this.emailExists=0;
                            this.$message({
                                type: 'error',
                                message: 'Email already exist. '
                            });
                        });
                    } else {
                        this.emailExists=-1;
                        this.$message({
                            type: 'error',
                            message: 'Please enter a valid email.'
                        });
                    }
                } else {
                    this.emailExists=-1;
                    this.$message({
                        type: 'error',
                        message: 'Please enter a email'
                    });
                }
            },
            isPhoneErr(phone, type){  
                if(type == 'cell'){
                    // var patt=/^\d{10,12}$/g;
                    if(phone != ''){
                        if(phone.length < 10){
                            return true;
                        }
                        if(phone.length > 15){
                            return true
                        }

                        return false;
                    }
                    else {
                        return false;
                    }

                }else{
                    // var patt=/^\d{10,12}$/g;
                    if(phone != ''){
                        if(phone.length < 10){
                            return true;
                        }
                        if(phone.length > 15){
                            return true
                        }
                        return false;
                    }
                    else {
                        return false;
                    }
                }               
            },
            async saveEmployeeData() {
                let availabilityData = {
                    "1": this.getAvailabilityFormat(this.weeklyVacationData.sun),
                    "2": this.getAvailabilityFormat(this.weeklyVacationData.mon),
                    "3": this.getAvailabilityFormat(this.weeklyVacationData.tue),
                    "4": this.getAvailabilityFormat(this.weeklyVacationData.wed),
                    "5": this.getAvailabilityFormat(this.weeklyVacationData.thu),
                    "6": this.getAvailabilityFormat(this.weeklyVacationData.fri),
                    "7": this.getAvailabilityFormat(this.weeklyVacationData.sat)
                };
                //console.log(availabilityData);
                //console.log(JSON.stringify(availabilityData));
                let addEmpData = {
                    client_id: this.userClientID,
                    display_name: this.personalInfo.basicInfo.userName,
                    first_name: this.personalInfo.basicInfo.firstName,
                    last_name: this.personalInfo.basicInfo.lastName,
                    // password: this.personalInfo.basicInfo.password,
                    email: this.personalInfo.contact.email,
                    secondary_email: this.personalInfo.contact.secEmail,
                    drivers_license: this.personalInfo.identityField.driverLicense,
                    social_security: this.personalInfo.identityField.socialSecurity,
                    dob: this.personalInfo.identityField.dataOfBirth + " " + Date().slice(16, 24),
                    mothers_maiden_name: this.personalInfo.identityField.monthMaidenName,
                    total_shifts: this.adminSettingsData.totalShifts,
                    member_since: this.adminSettingsData.memberSince + " " + Date().slice(16, 24),
                    date_of_hire: this.adminSettingsData.dateOfHire + " " + Date().slice(16, 24),
                    sreet_address: this.personalInfo.address.streetAdd,
                    sreet_city: this.personalInfo.address.city,
                    street_state: this.personalInfo.address.state,
                    street_postcode: this.personalInfo.address.zip,
                    street_country: this.personalInfo.address.country,
                    po_box_address: this.personalInfo.PoBoxAddress.pbAdd,
                    po_box_city: this.personalInfo.PoBoxAddress.city,
                    po_box_state: this.personalInfo.PoBoxAddress.state,
                    po_box_postcode: this.personalInfo.PoBoxAddress.zip,
                    po_box_country: this.personalInfo.PoBoxAddress.country,
                    home_phone: this.personalInfo.contact.homePhone,
                    cell_phone: this.personalInfo.contact.cellPhone,
                    contact_name: this.personalInfo.emergency.contactName,
                    contact_number: this.personalInfo.emergency.contactNuber,
                    medical_conditions_note: this.personalInfo.emergency.medicalCondition,
                    regular_medications: this.personalInfo.emergency.regularMeication,
                    home_phone_no: this.personalInfo.emergency.homePhone,
                    cell_phone_no: this.personalInfo.emergency.cellPhone,
                    emergency_email: this.personalInfo.emergency.email,
                    skills: JSON.stringify(this.skillData.selectedSkills),
                    skill_lock: (this.skillData.updateAuthority) ? 1 : 0,
                    employee_status_id: this.adminSettingsData.status,
                    vacation_start: '',
                    vacation_end: '',
                    image: (this.personalInfo.new_files.length != 0) ? this.personalInfo.new_files[0].path : '',
                    available_times: JSON.stringify(availabilityData),
                    seniority: this.adminSettingsData.seniority,
                    custom_field1:JSON.stringify({'name':this.custom_field_1, 'value':this.personalInfo.customFields.custom_field_1}), 
                    custom_field2: JSON.stringify({'name':this.custom_field_2, 'value':this.personalInfo.customFields.custom_field_2}), 
                };
                await this.customValEmail(addEmpData.email);

                // if(addEmpData.cell_phone == '' || addEmpData.cell_phone == '') {
                //     this.$message({
                //         type: 'error',
                //         message: 'Both of your Phone Numbers or One of your phone numbers is empty'
                //     });   
                // }
                    
                if( addEmpData.first_name =='' || 
                    addEmpData.last_name =='' || 
                    this.emailExists != 1 || 
                    this.isPhoneErr(addEmpData.cell_phone,'cell') ||
                    this.isPhoneErr(addEmpData.home_phone,'home')){

                    // console.log(addEmpData.first_name)
                    // console.log(addEmpData.last_name)
                    // console.log(this.emailExists)
                    // console.log(this.isPhoneErr(addEmpData.cell_phone, 'cell'))
                    // console.log(this.isPhoneErr(addEmpData.cell_phone, 'home'))
                    // if(this.emailExists==1)
                    if(this.emailExists==1){
                        this.$message({
                            type: 'error',
                            message: this.$t('please_input_personal_info_fields')
                        });
                    }
                                        
                }else if(JSON.parse(addEmpData.skills).length == 0){
                    this.$message({
                        type: 'error',
                        message: this.$t('profile_error_skill')
                    });    
                }else if(addEmpData.employee_status_id ==''){
                    this.$message({
                        type: 'error',
                        message: this.$t('please_select_status_from_admin_settings')
                    });
                }else{
                    this.btnLoading = true;
                    await service.post('employee', addEmpData, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                       let resData = res.data;
                            if(resData.status_code==0){                           
                            this.$message({
                                type: 'error',
                                message: resData.status_message
                                    ? this.getErrorMessage(resData.status_message)
                                    : this.$t('something_went_wrong')
                            });
                                // message: (res.data['status_message']) ? (res.data['status_message'][0] == "mailbox_does_not_exist" ? this.$t(res.data['status_message'][0]) : res.data['status_message'][0]) : this.$t('something_went_wrong')
                            return;
                        } else if(reData){
                            this.$message({
                                type: 'success',
                                message: this.$t('employee_created_successfully')
                            });
                            
                            this.$router.push({
                                'path': '/editEmployee/'+btoa(resData.result.id)
                            });
                        }else{
                            this.$message({
                                type: 'error',
                                message: status_message.toString()
                            });
                        }
                        
                    }).catch((err) => {
                        console.log('error',err);
                        this.$message({
                            type: 'error',
                            message: this.$t('please_input_all_required_fields')
                        });
                    }); 
                    this.btnLoading = false;
                }

            }
        },

        created() {
            bus.$on('onUpdatePersonalDetails', (data) => {
                this.personalInfo = data;
                // console.log("Emit fire..",this.personalInfo,this.personalInfo.emailExists);
            });
            bus.$on('onUpdateSkillList', (data) => {
                this.skillData = data;
                //console.log("Emit fire..",data);
            });
            bus.$on('onUpdateAdminSettings', (data) => {
                this.adminSettingsData = data;
                //console.log("Emit fire..",data);
            });
            bus.$on('onUpdateVacation', (data) => {
                this.weeklyVacationData = data;
                //console.log("Emit fire..",data);
            });

            service.get('client/'+this.userClientID, {
                'Authorization': this.userToken
            }).
            then((res) => {
                //this.turnoverTime=res.data.result.turnover;
                this.skillData.updateAuthority=(res.data.result.skill_lock==1)? 'locked' : 'unlocked';
                //console.log(res.data.result);
                this.custom_field_1=res.data.result.custom_field_1;
                this.custom_field_2=res.data.result.custom_field_2;
            }).catch((err) => {
                console.log(err);
            });
        }
    }

</script>
